export function loadOneTrustScript() {
  const scriptSrc =
    import.meta.env.VITE_ONETRUST_SCRIPT_URL ||
    "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
  const domainScriptId =
    import.meta.env.VITE_ONETRUST_DOMAIN_SCRIPT_ID ??
    "01997674-f410-7e26-92a5-f69fb8d1c99c";

  if (!domainScriptId) {
    console.warn("OneTrust script not loaded: missing env variables.");
    return;
  }

  // Main OneTrust script
  const script = document.createElement("script");
  script.src = scriptSrc;
  script.type = "text/javascript";
  script.charset = "UTF-8";
  script.setAttribute("data-domain-script", domainScriptId);

  // Optional: log when script loads
  script.onload = () => {
    console.log("OneTrust script loaded");
  };

  document.body.appendChild(script);

  // Add OptanonWrapper function - called when OneTrust consent is processed
  const wrapperScript = document.createElement("script");
  wrapperScript.type = "text/javascript";
  wrapperScript.innerHTML = `
    function OptanonWrapper() { 
      console.log("OneTrust consent processed - ready to load analytics");
      // Dispatch event to signal OneTrust is ready
      window.dispatchEvent(new Event('onetrust-ready'));
    }
  `;

  document.body.appendChild(wrapperScript);
}
